/**
 * Skin Quiz Results Module
 *
 * TECHNICAL DEBT NOTE:
 * - This page uses Slick Carousel
 * - Quiz page (skin-quiz.liquid) uses Flickity
 * - Ideally should standardize on one library (Slick recommended since it's more widely used)
 * - Requires careful testing if migrating quiz page to Slick
 */

// Debug flag - set to true for development, false for production
const SKIN_QUIZ_DEBUG = false;

// Helper function for conditional logging
function debugLog(...args) {
  if (SKIN_QUIZ_DEBUG) {
    debugLog('', ...args);
  }
}

function debugWarn(...args) {
  if (SKIN_QUIZ_DEBUG) {
    debugWarn('', ...args);
  }
}

function debugError(...args) {
  // Always log errors
  debugError('', ...args);
}

debugLog('Script loaded at:', new Date().toISOString());

// ============================================
// CONSTANTS - Magic strings centralized here
// ============================================

// localStorage keys
const STORAGE_KEYS = {
  QUIZ_DATA: 'skinQuizData',
  QUIZ_PROFILE: 'skinQuizProfile',
  QUIZ_COMPLETED: 'skinQuizCompleted',
  CURRENT_QUESTION: 'skinQuizCurrentQuestion',
  SELECTED_PRODUCTS: STORAGE_KEYS.SELECTED_PRODUCTS
};

// Product field names for routine steps
const PRODUCT_FIELDS = {
  AM_CLEANSER: 'am_cleanser',
  PM_CLEANSER: 'pm_cleanser',
  EYE_CREAM: 'eye_cream',
  MOISTURIZER: 'moisturizer',
  PIGMENT_TREATMENT: 'pigment_treatment',
  NON_PIGMENT_TREATMENT: 'non_pigment_treatment',
  RETINOL: 'retinol',
  RETINOL_ALTERNATIVE: 'retinol_alternative',
  PHYSICAL_UNTINTED: 'physical_untinted',
  PHYSICAL_TINTED: 'physical_tinted',
  CHEMICAL_UNTINTED: 'chemical_untinted',
  CHEMICAL_TINTED: 'chemical_tinted',
  NO_PREFERENCE_UNTINTED: 'no_preference_untinted',
  NO_PREFERENCE_TINTED: 'no_preference_tinted'
};

// Skin concerns
const SKIN_CONCERNS = {
  HYPERPIGMENTATION: 'Hyperpigmentation',
  ACNE_PRONE: 'Acne-Prone',
  REDNESS_ROSACEA: 'Redness/Rosacea',
  FINE_LINES: 'Fine Lines/Wrinkles',
  DARK_CIRCLES: 'Dark Circles',
  DEHYDRATION: 'Dehydration',
  UNEVEN_TEXTURE: 'Uneven Texture',
  DULLNESS: 'Dullness'
};

// Sunscreen preferences
const SUNSCREEN_PREFS = {
  TYPES: {
    PHYSICAL: 'Physical',
    CHEMICAL: 'Chemical',
    NO_PREFERENCE: 'NoPreference'
  },
  COLORS: {
    TINTED: 'Tinted',
    UNTINTED: 'Untinted'
  }
};

// Debounce helper function - delays execution until after wait period of no calls
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Throttle helper function - limits execution to once per wait period
function throttle(func, limit) {
  let inThrottle;
  return function executedFunction(...args) {
    if (!inThrottle) {
      func(...args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}

  // Shared Slick slider configuration
  const SLICK_CONFIG = {
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: false,
    draggable: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          draggable: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 2,
          draggable: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
          draggable: true
        }
      }
    ]
  };

  // Initialize a single slider element
  function initSingleSlider($slider) {
    if ($slider.hasClass('slick-initialized')) {
      return; // Already initialized
    }
    if ($slider.children().length === 0) {
      debugLog('Skipping empty slider:', $slider.attr('class'));
      return; // No products to show
    }
    debugLog('Initializing slider:', $slider.attr('class'));
    $slider.slick(SLICK_CONFIG);
  }

  // Function to initialize all product sliders with Slick
  // Uses requestAnimationFrame for better timing instead of arbitrary setTimeout
  function initializeProductSliders() {
    debugLog('Starting Slick slider initialization');

    // Wait for next frame to ensure DOM is settled
    requestAnimationFrame(function() {
      // Double RAF for extra safety (after browser paint)
      requestAnimationFrame(function() {
        const $sliders = $('.custom-products-slider').not('.slick-initialized');

        if ($sliders.length === 0) {
          debugLog('No uninitialized sliders found');
          return;
        }

        $sliders.each(function() {
          initSingleSlider($(this));
        });

        debugLog('Slick sliders initialized:', $sliders.length);
      });
    });
  }

    // Consolidated jQuery document ready handler
    $(document).ready(function() {
      // Quantity button click handler
      $(document).on('click', '.quantity-btn', function() {
        const input = $(this).siblings('.quantity-input');
        let value = parseInt(input.val());

        if ($(this).hasClass('plus')) {
          value = isNaN(value) ? 1 : Math.min(value + 1, parseInt(input.attr('max')) || value + 1);
        } else if ($(this).hasClass('minus')) {
          value = isNaN(value) ? 1 : Math.max(value - 1, parseInt(input.attr('min')) || 1);
        }

        input.val(value).trigger('change');

        // Update total price when quantity changes
        updateTotalPrice();
      });

      // Quantity input change handler
      $(document).on('change', '.quantity-input', function() {
        let value = parseInt($(this).val());
        const min = parseInt($(this).attr('min')) || 1;
        const max = parseInt($(this).attr('max')) || Infinity;

        if (isNaN(value) || value < min) {
          value = min;
        } else if (value > max) {
          value = max;
        }

        $(this).val(value);
      });

      // Prevent non-numeric input in quantity fields
      $(document).on('keydown', '.quantity-input', function(e) {
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
            (e.keyCode == 65 && e.ctrlKey === true) ||
            (e.keyCode >= 35 && e.keyCode <= 39)) {
          return;
        }
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          e.preventDefault();
        }
      });

      // Custom input checkbox click handler
      $(document).on('click', '.custom-input', function() {
        $(this).parent().parent().find(".quantity-input").val(1);
        $('body').find(".custom_active").removeClass("custom_active");

        if ($(this).prop('checked')) {
          $(this).parent().find(".quantity-input").addClass("custom_active");
        }

        updateTotalPrice();
      });

      // Add to cart button click handler
      $(document).on('click', '.button-custom', function(){
        var productsToAdd = [];
        var $button = $(this);

        $('.custom-input').each(function() {
          if ($(this).prop('checked')) {
            var qt = $(this).parent().find(".custom_active").val() || 1;
            var ProVariantVal = $(this).val();
            productsToAdd.push({
              id: ProVariantVal,
              quantity: parseInt(qt)
            });
          }
        });

        if (productsToAdd.length === 0) {
          console.log("[SKIN-QUIZ-NEW] No products selected");
          return;
        }

        // Disable button during request
        $button.prop('disabled', true).text('Adding...');

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify({ items: productsToAdd }),
          contentType: 'application/json',
          dataType: 'json',
          success: function(response) {
            console.log("[SKIN-QUIZ-NEW] Products added to cart:", response);
            $button.text('Added!');
            setTimeout(function() {
              $button.prop('disabled', false).text('ADD TO CART');
            }, 1500);
            // Open the cart sidebar
            if (typeof Shopify !== 'undefined' && typeof Shopify.getCart === 'function') {
              Shopify.getCart(function(cart) {
                $('body').addClass('cart-sidebar-show');
                if (typeof halo !== 'undefined' && typeof halo.updateSidebarCart === 'function') {
                  halo.updateSidebarCart(cart);
                }
              });
            }
          },
          error: function(error) {
            console.error("[SKIN-QUIZ-NEW] Error adding to cart:", error);
            $button.prop('disabled', false).text('Add to Cart');
            alert('Error adding products to cart. Please try again.');
          }
        });

        console.log("[SKIN-QUIZ-NEW] Products to add:", productsToAdd);
      });
    });

    // Helper function to update total price display
    function updateTotalPrice() {
      var totalPrice = 0;
      var symbol = '$';
      var seenVariants = {};

      $('.custom-input:checked').each(function() {
        var variantId = $(this).val();
        var price = parseFloat($(this).attr('product-price')) || 0;
        var qty = parseInt($(this).parent().find('.quantity-input').val()) || 1;

        // Only count price once per variant (same product in AM/PM)
        if (!seenVariants[variantId]) {
          totalPrice += price * qty;
          seenVariants[variantId] = true;
        }

        // Get currency symbol from data attribute
        var currencyAttr = $(this).attr('data-currency');
        if (currencyAttr) symbol = currencyAttr;
      });

      // Update total display
      $('.custom-total').text(symbol + (totalPrice / 100).toFixed(2));

      // Update bottom bar total price
      var bottomBarTotalPrice = document.getElementById('bottomBarTotalPrice');
      if (bottomBarTotalPrice) {
        bottomBarTotalPrice.textContent = symbol + (totalPrice / 100).toFixed(2);
      }

      // Update button state
      if ($('.custom-input:checked').length > 0) {
        $(".button-custom").css({
          "background-color": "#000",
          "color": "#fff"
        });
      } else {
        $(".button-custom").css({
          "background-color": "#ccc",
          "color": "#000"
        });
      }
    }

    // Single-check behavior: only one product can be selected per step
    // Using event delegation instead of 100 individual handlers
    document.addEventListener('click', function(e) {
      if (e.target.classList.contains('single-check')) {
        const checkbox = e.target;
        if (checkbox.checked) {
          // Find the parent slider container (AM or PM), not the whole step
          const custombox = checkbox.closest('.custom-products-slider') || checkbox.closest('[class*="custombox"]');
          if (custombox) {
            // Uncheck all other single-check checkboxes in the same slider
            custombox.querySelectorAll('.single-check').forEach(otherCheckbox => {
              if (otherCheckbox !== checkbox) {
                otherCheckbox.checked = false;
                // Also hide the quantity selector for unchecked items
                const label = otherCheckbox.closest('label');
                if (label) {
                  const qtySelector = label.querySelector('.quantity-selector');
                  if (qtySelector) qtySelector.style.display = 'none';
                }
              }
            });
          }
        }
      }
    });

    // Function to initialize slick sliders
    function initializeSliders() {
      debugLog(' Initializing sliders');
      $('.custom-products-slider').not('.slick-initialized').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        draggable: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              draggable: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              draggable: true
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              draggable: true
            }
          }
        ]
      });
    }

    // Open all accordion panels by default on page load
    var acc = document.getElementsByClassName("accordion");
    for (var i = 0; i < acc.length; i++) {
      acc[i].classList.add("active");
    }

    // Make accordion items clickable
    document.querySelectorAll('.accordion').forEach(function(accordion) {
      accordion.addEventListener('click', function() {
        this.classList.toggle('active');
        const panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  
  // Helper: compare a metaobject field (may be array or string) with a string value
  function fieldMatchesValue(fieldValue, searchValue) {
    if (Array.isArray(fieldValue)) {
      return fieldValue.includes(searchValue);
    }
    return fieldValue === searchValue;
  }

  // Helper: check if a routine has real products for a given field
  function routineHasProducts(routine, field) {
    var val = routine.products && routine.products[field];
    if (!val) return false;
    if (Array.isArray(val) && val.length > 0) return true;
    if (typeof val === 'string' && val !== '[]' && val !== '') return true;
    return false;
  }

  // Helper: normalize a product field value (handle double-encoded strings)
  function normalizeProductField(val) {
    if (!val) return [];
    if (Array.isArray(val)) return val;
    if (typeof val === 'string') {
      try { var parsed = JSON.parse(val); return Array.isArray(parsed) ? parsed : []; } catch(e) { return []; }
    }
    return [];
  }

  // Helper function to show user-friendly error message
  function showRoutineError(message) {
    const stepsContainer = document.getElementById('routine-steps-container');
    if (stepsContainer) {
      stepsContainer.innerHTML = `
        <div class="routine-error" style="text-align: center; padding: 40px 20px; background: #fff3cd; border: 1px solid #ffc107; border-radius: 8px; margin: 20px 0;">
          <h3 style="color: #856404; margin-bottom: 10px;">Unable to Load Your Routine</h3>
          <p style="color: #856404; margin-bottom: 20px;">${escapeHtml(message)}</p>
          <a href="/pages/skin-type-quiz" class="button" style="background: #000; color: #fff; padding: 12px 24px; text-decoration: none; display: inline-block;">Retake the Quiz</a>
        </div>
      `;
    }
  }

  // Function to load product data from metaobject and create steps
  function loadProductData() {
    try {
      // Check if the data element exists
      const dataElement = document.getElementById('routineProductsData');
      if (!dataElement) {
        debugError('routineProductsData element not found in DOM');
        showRoutineError('Product data could not be loaded. Please try refreshing the page.');
        return;
      }

      // Try to parse the JSON data
      let routineProductsData;
      try {
        routineProductsData = JSON.parse(dataElement.textContent);
      } catch (parseError) {
        debugError('Failed to parse routineProductsData JSON:', parseError);
        showRoutineError('Product data is corrupted. Please try refreshing the page.');
        return;
      }

      // Validate the data structure
      if (!routineProductsData || typeof routineProductsData !== 'object') {
        debugError('routineProductsData is not a valid object');
        showRoutineError('Product data is in an unexpected format.');
        return;
      }

      if (!routineProductsData.routines || !Array.isArray(routineProductsData.routines)) {
        debugError('routineProductsData.routines is not an array');
        showRoutineError('No skincare routines are available.');
        return;
      }

      if (routineProductsData.routines.length === 0) {
        debugError('routineProductsData.routines is empty');
        showRoutineError('No skincare routines have been configured yet.');
        return;
      }

      // Load skin quiz data first
      const skinProfile = loadSkinQuizData();
      let selectedRoutine = null;

      // Try to find a matching routine based on skin profile
      if (skinProfile) {
        for (const routine of routineProductsData.routines) {
          if (fieldMatchesValue(routine.skin_type, skinProfile.skinType) &&
              fieldMatchesValue(routine.sensitivity, skinProfile.sensitivity) &&
              fieldMatchesValue(routine.concern, skinProfile.primaryConcern)) {
            selectedRoutine = routine;
            break;
          }
        }

        // If no exact match, try matching just skin type
        if (!selectedRoutine) {
          for (const routine of routineProductsData.routines) {
            if (fieldMatchesValue(routine.skin_type, skinProfile.skinType)) {
              selectedRoutine = routine;
              break;
            }
          }
        }
      }

      // Default to first routine if no match found
      if (!selectedRoutine && routineProductsData.routines.length > 0) {
        selectedRoutine = routineProductsData.routines[0];
        debugLog('Using first routine as fallback - no exact match for skin profile');
      }

      if (!selectedRoutine) {
        debugError('No routine could be selected');
        showRoutineError('We couldn\'t find a routine matching your skin profile. Please retake the quiz.');
        return;
      }
      
      // Define the standard skincare routine steps
      const routineSteps = [
        { number: 1, name: 'Cleanser', am: 'am_cleanser', pm: 'pm_cleanser' },
        { number: 2, name: 'Eye Cream', am: 'eye_cream', pm: 'eye_cream' },
        { number: 3, name: 'Treatment', am: 'non_pigment_treatment', pm: 'non_pigment_treatment' },
        { number: 4, name: 'Moisturizer', am: 'moisturizer', pm: 'moisturizer' },
        { number: 5, name: 'Sunscreen', am: 'physical_untinted', pm: null }
      ];
      
      // Customize treatment field if user has pigmentation concerns
      if (skinProfile && skinProfile.primaryConcern === 'Hyperpigmentation') {
        const treatmentStep = routineSteps.find(step => step.name === 'Treatment');
        if (treatmentStep) {
          treatmentStep.am = 'pigment_treatment';
          treatmentStep.pm = 'pigment_treatment';
        }
      }
      
      // Customize sunscreen field based on preferences
      if (skinProfile && skinProfile.sunscreenPrefs) {
        const sunscreenStep = routineSteps.find(step => step.name === 'Sunscreen');
        if (sunscreenStep) {
          if (skinProfile.sunscreenPrefs.type === 'Physical' && skinProfile.sunscreenPrefs.color === 'Untinted') {
            sunscreenStep.am = 'physical_untinted';
          } else if (skinProfile.sunscreenPrefs.type === 'Physical' && skinProfile.sunscreenPrefs.color === 'Tinted') {
            sunscreenStep.am = 'physical_tinted';
          } else if (skinProfile.sunscreenPrefs.type === 'Chemical' && skinProfile.sunscreenPrefs.color === 'Untinted') {
            sunscreenStep.am = 'chemical_untinted';
          } else if (skinProfile.sunscreenPrefs.type === 'Chemical' && skinProfile.sunscreenPrefs.color === 'Tinted') {
            sunscreenStep.am = 'chemical_tinted';
          } else if (skinProfile.sunscreenPrefs.type === 'NoPreference' && skinProfile.sunscreenPrefs.color === 'Untinted') {
            sunscreenStep.am = 'no_preference_untinted';
          } else if (skinProfile.sunscreenPrefs.type === 'NoPreference' && skinProfile.sunscreenPrefs.color === 'Tinted') {
            sunscreenStep.am = 'no_preference_tinted';
          }
        }
      }
      
      // Modify routine based on pregnancy status
      if (skinProfile && skinProfile.isPregnant) {
        const retinolStep = routineSteps.find(step => step.name === 'Retinol/Retinoid');
        if (retinolStep) {
          retinolStep.pm = 'retinol_alternative';
        } else {
          // Add a special retinol alternative step if pregnant
          routineSteps.splice(4, 0, { 
            number: 4, 
            name: 'Retinol Alternative', 
            am: null, 
            pm: 'retinol_alternative',
            note: 'Pregnancy-safe alternatives to retinol'
          });
          // Adjust numbering for subsequent steps
          for (let i = 4; i < routineSteps.length; i++) {
            routineSteps[i].number = i + 1;
          }
        }
      } else {
        // Add retinol step for non-pregnant users if not already present
        const hasRetinol = routineSteps.some(step => step.name === 'Retinol/Retinoid');
        if (!hasRetinol) {
          routineSteps.splice(4, 0, { 
            number: 4, 
            name: 'Retinol/Retinoid', 
            am: null, 
            pm: 'retinol'
          });
          // Adjust numbering for subsequent steps
          for (let i = 4; i < routineSteps.length; i++) {
            routineSteps[i].number = i + 1;
          }
        }
      }
      
      // Create HTML for the categories
      const categoriesContainer = document.getElementById('routine-categories');
      if (categoriesContainer) {
        let categoriesHTML = '';
        routineSteps.forEach((step, index) => {
          categoriesHTML += `<div>${step.number}. ${step.name}<span class="itemqt itemcount${index + 1}">0</span></div>`;
        });
        categoriesContainer.innerHTML = categoriesHTML;
      }

      // Global event handlers - only attach once
      let handlersInitialized = false;
      let isProcessingChange = false; // Flag to prevent double processing of change events

      function initializeHandlers() {
        if (handlersInitialized) {
          debugLog(' Handlers already initialized, skipping');
          return;
        }

        debugLog(' Initializing event handlers ONCE');
        handlersInitialized = true;

        // QUANTITY BUTTONS - Delegate to document level
        document.addEventListener('click', function(event) {
          let quantityBtn = event.target.closest('.quantity-btn');

          if (quantityBtn) {
            debugLog(' Quantity button clicked', quantityBtn);
            event.preventDefault();
            event.stopPropagation();
            
            const quantitySelector = quantityBtn.closest('.quantity-selector');
            const input = quantitySelector?.querySelector('.quantity-input');
            
            if (!input) {
              debugWarn(' No quantity input found for quantity button.');
              return;
            }
            
            let value = parseInt(input.value) || 1;
            if (quantityBtn.classList.contains('plus')) {
              value = Math.min(value + 1, 99);
            } else {
              value = Math.max(value - 1, 1);
            }
            input.value = value;

            // After quantity change, use debounced refresh for better performance
            // when rapidly clicking +/- buttons
            debouncedRefreshUI();

          } else {
              // Check if the click was on an interactive element *within* the product card first
              const isInteractiveElement = event.target.closest('.quantity-selector, .closebtn') || 
                                           event.target.tagName === 'INPUT' || 
                                           event.target.tagName === 'BUTTON'; // Also check for BUTTON tag explicitly

              const productLabel = event.target.closest('label'); // Find the parent label
              const checkbox = productLabel ? productLabel.querySelector('.custom-input') : null;

              if (!isInteractiveElement && productLabel && checkbox) {
                  // If the click was on a label containing a checkbox, and not an interactive element,
                  // log it and let the browser's default action proceed.
                  // The browser will toggle the checkbox and fire a 'change' event.
                  debugLog(' Click on label area detected, allowing default action for:', productLabel);
                  // No preventDefault() or stopPropagation() here, to allow natural behavior.
              } else if (!isInteractiveElement) {
                  // Click was not on an interactive element, nor a recognized product label with a checkbox.
                  debugLog(' Click detected on non-interactive, non-label area or label without checkbox.', event.target);
              } else {
                  // Click was on a recognized interactive element.
                  debugLog(' Click detected on an interactive element, letting default/other handlers manage.', event.target);
              }
          }
        }, true);

        // CHECKBOX CHANGES - Delegate to document level
        document.addEventListener('change', function(event) {
          if (event.target.classList && event.target.classList.contains('custom-input')) {
            debugLog(' Checkbox changed (event target):', event.target);

            // Prevent re-entrancy / double processing
            if (isProcessingChange) {
                debugLog(' Change event ignored (already processing)');
                return;
            }
            isProcessingChange = true;
            debugLog(' Processing change event...');
            
            const changedCheckbox = event.target;
            
            const label = changedCheckbox.closest('label');
            const quantitySelector = label?.querySelector('.quantity-selector');
            
            if (!label || !quantitySelector) {
                debugWarn(' Could not find label or quantity selector for changed checkbox.', changedCheckbox);
                 // Reset flag even if elements not found
                 setTimeout(() => {
                     debugLog(' Resetting change processing flag (early exit).');
                     isProcessingChange = false;
                 }, 0);
                refreshAllSkincareStepUI(); // Still refresh UI 
                return; // Exit early if essential elements are missing
            }
            
            if (changedCheckbox.checked) {
                debugLog(' Checkbox is now checked:', changedCheckbox.value);
                quantitySelector.style.display = 'flex';
                
                // ---- Single selection logic ----
                const name = changedCheckbox.name;
                const sliderContainer = changedCheckbox.closest('.custom-products-slider');
                if (sliderContainer) {
                    sliderContainer.querySelectorAll(`.custom-input[name="${name}"]`).forEach(otherCheckbox => {
                        if (otherCheckbox !== changedCheckbox && otherCheckbox.checked) {
                            debugLog(' (Change Handler) Unchecking other checkbox:', otherCheckbox.value);
                            otherCheckbox.checked = false;
                            const otherLabel = otherCheckbox.closest('label');
                            const otherQuantitySelector = otherLabel?.querySelector('.quantity-selector');
                            if (otherQuantitySelector) {
                                otherQuantitySelector.style.display = 'none';
                            }
                        }
                    });
                }
                // ---- END Single selection logic ----

            } else {
              debugLog(' Checkbox is now unchecked:', changedCheckbox.value);
              quantitySelector.style.display = 'none';
            }
            
            // After all checkbox changes triggered by this initial event are complete, refresh the entire UI state.
            refreshAllSkincareStepUI();

            // Reset the flag shortly after to allow subsequent events
            setTimeout(() => {
                debugLog(' Resetting change processing flag.');
                isProcessingChange = false;
            }, 0);
          }
        }, true);
      }
      
      // Initialize handlers after DOM content is loaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeHandlers);
      } else {
        // DOM already loaded, initialize immediately
        initializeHandlers();
      }

      // Create the steps containers
      const stepsContainer = document.getElementById('routine-steps-container');
      if (stepsContainer) {
        let stepsHTML = '';
        
        routineSteps.forEach((step, index) => {
          const stepId = `step-${step.name.toLowerCase().replace(/[^a-z0-9]/g, '-')}`;
          const hasAM = step.am && routineHasProducts(selectedRoutine, step.am);
          const hasPM = step.pm && routineHasProducts(selectedRoutine, step.pm);
          
          stepsHTML += `
            <div class="accordion-custom">
              <div class="accordion-custom-item active">
                <div class="accordion">
                  <h2>${step.number}. ${step.name}</h2>
                  <div class="day-night-toggle" ${step.name === 'Sunscreen' ? 'style="justify-content: flex-start;"' : ''}>
                    <button type="button" class="toggle-btn am-btn ${hasAM ? 'active' : 'disabled'}" onclick="toggleDayNight(this, 'am', '${stepId}')">
                      <svg class="sun-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="5"/>
                        <line x1="12" y1="1" x2="12" y2="3"/>
                        <line x1="12" y1="21" x2="12" y2="23"/>
                        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
                        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                        <line x1="1" y1="12" x2="3" y2="12"/>
                        <line x1="21" y1="12" x2="23" y2="12"/>
                        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
                        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
                      </svg>
                      Day
                    </button>
                    ${step.name !== 'Sunscreen' ? `
                    <button type="button" class="toggle-btn pm-btn ${!hasAM && hasPM ? 'active' : ''}" onclick="toggleDayNight(this, 'pm', '${stepId}')">
                      <svg class="moon-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                      </svg>
                      Night
                    </button>` : ''}
                  </div>
                </div>
                <div class="accordion-custom-content custombox${index + 1} panel">
                  ${step.note ? `<p class="step-note">${step.note}</p>` : ''}
                  <div class="custom-products-slider responsive am-products ${stepId}-am-products" ${!hasAM || hasPM && !hasAM ? 'style="display: none;"' : ''}>
                    <!-- AM products -->
                  </div>
                  <div class="custom-products-slider responsive pm-products ${stepId}-pm-products" ${hasAM || !hasPM ? 'style="display: none;"' : ''}>
                    <!-- PM products -->
                  </div>
                </div>
              </div>
            </div>
          `;
        });
        
        stepsContainer.innerHTML = stepsHTML;
        
        // Now populate products
        routineSteps.forEach((step, index) => {
          const stepId = `step-${step.name.toLowerCase().replace(/[^a-z0-9]/g, '-')}`;
          
          if (step.am) {
            const amContainer = document.querySelector(`.${stepId}-am-products`);
            if (amContainer) {
              populateProducts(selectedRoutine, step.am, stepId + '-am-products');
            }
          }
          
          if (step.pm) {
            const pmContainer = document.querySelector(`.${stepId}-pm-products`);
            if (pmContainer) {
              populateProducts(selectedRoutine, step.pm, stepId + '-pm-products');
            }
          }
        });
        
        // Initialize Slick sliders after all products are populated
        debugLog(' All products populated, initializing Slick sliders');
        initializeProductSliders();
      }
    } catch (error) {
      debugError('Error loading product data:', error);
      showRoutineError('An unexpected error occurred while loading your routine. Please try refreshing the page.');
    }
  }
  
  // Function to populate products in the corresponding container
  function populateProducts(routineData, fieldName, containerClass) {
    console.log(`[SKIN-QUIZ-NEW] Populating products for ${fieldName} in ${containerClass}`, routineData);
    const container = document.querySelector(`.${containerClass}`);
    if (!container) {
      console.error(`[SKIN-QUIZ-NEW] Container ${containerClass} not found`);
      // Debug all available containers
      const allContainers = document.querySelectorAll('[class*="-products"]');
      console.log(`[SKIN-QUIZ-NEW] Available product containers (${allContainers.length}):`, 
        Array.from(allContainers).map(el => el.className));
      return;
    }
    console.log(`[SKIN-QUIZ-NEW] Found container for ${containerClass}:`, container);
    
    let productsHtml = '';
    
    // Ensure we have valid product data (handle double-encoded strings from Liquid)
    let products = [];
    if (routineData && routineData.products && routineData.products[fieldName]) {
      products = normalizeProductField(routineData.products[fieldName]);
      // If normalizeProductField returned empty but value is a non-array object, wrap it
      if (products.length === 0 && typeof routineData.products[fieldName] === 'object' && !Array.isArray(routineData.products[fieldName])) {
        products = [routineData.products[fieldName]];
      }
    }
    
    console.log(`[SKIN-QUIZ-NEW] Processing ${products.length} products for ${fieldName}:`, products);
    
    if (products.length > 0) {
      // Generate HTML for each product
      products.forEach(product => {
        if (!product) return; // Skip if product is null or undefined
        
        // Log product data for debugging
        const variant = product.variants && product.variants.length > 0 ? product.variants[0] : null;
        const variantId = variant ? variant.id : (product.variant_id || product.id || '');
        const sku = variant && variant.sku ? variant.sku : (product.sku || 'N/A');
        
        // Get image URL
        let imageUrl = '';
        if (product.featured_image && typeof product.featured_image === 'string') {
          imageUrl = product.featured_image;
        } else if (product.featured_image && product.featured_image.src) {
          imageUrl = product.featured_image.src;
        } else if (product.images && product.images.length > 0) {
          imageUrl = typeof product.images[0] === 'string' ? product.images[0] : (product.images[0].src || '');
        } else if (product.image) {
          imageUrl = product.image;
        }
        
        // Format price
        let priceHtml = '';
        let price = 0;
        if (variant && variant.price) {
          price = variant.price;
          priceHtml = formatMoney(price);
        } else if (product.price) {
          price = product.price;
          priceHtml = formatMoney(price);
        } else {
          priceHtml = '$0.00';
        }
        
        // Get the variant name which includes both product title and size
        const productName = variant ? variant.name : (product.name || product.title || 'Product');
        // Product title
        const title = product.title || (variant ? variant.title : '') || 'Product';
        const productSize = product.size || title;
        
        // Create product card HTML - escape user content to prevent XSS
        const safeProductName = escapeHtml(productName);
        const safeImageUrl = escapeHtml(imageUrl);
        productsHtml += `
          <label>
            <input type="checkbox" class="custom-input single-check" name="${escapeHtml(fieldName)}" value="${escapeHtml(variantId)}" product-price="${price}" data-currency="$">
            <div class="custom-product-card" data-price="${priceHtml}" data-product-id="${escapeHtml(product.id)}" data-variant-id="${escapeHtml(variantId)}">
              <img src="${safeImageUrl}" alt="${safeProductName}">
              <div class="custom-content-price">
                <p>${safeProductName}</p>
                <span>${priceHtml}</span>
              </div>
              <div class="quantity-selector">
                <button type="button" class="quantity-btn minus" data-currency="$">-</button>
                <input type="number" class="quantity-input custom_active" value="1" min="1" max="99">
                <button type="button" class="quantity-btn plus" data-currency="$">+</button>
              </div>
            </div>
            <div class="closebtn">
              <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#0F1729" style="fill: #fff;"></path>
              </svg>
            </div>
          </label>
        `;
      });
    } else {
      console.warn(`[SKIN-QUIZ-NEW] No products found for ${fieldName}, using fallback products`);
      // Use fallback products based on the fieldName
      const fallbackProducts = getFallbackProducts(fieldName);
      
      if (fallbackProducts && fallbackProducts.length > 0) {
        fallbackProducts.forEach(product => {
          const safeFallbackName = escapeHtml(product.size || product.title);
          const safeFallbackImageUrl = escapeHtml(product.imageUrl);
          productsHtml += `
            <label>
              <input type="checkbox" class="custom-input single-check" name="${escapeHtml(fieldName)}" value="${escapeHtml(product.variantId)}" product-price="${product.price}" data-currency="$">
              <div class="custom-product-card" data-price="${escapeHtml(product.priceFormatted)}" data-product-id="${escapeHtml(product.id)}" data-variant-id="${escapeHtml(product.variantId)}">
                <img src="${safeFallbackImageUrl}" alt="${safeFallbackName}">
                <div class="custom-content-price">
                  <p>${safeFallbackName}</p>
                  <span>${escapeHtml(product.priceFormatted)}</span>
                </div>
                <div class="quantity-selector">
                  <button type="button" class="quantity-btn minus" data-currency="$">-</button>
                  <input type="number" class="quantity-input custom_active" value="1" min="1" max="99">
                  <button type="button" class="quantity-btn plus" data-currency="$">+</button>
                </div>
              </div>
              <div class="closebtn">
                <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#0F1729" style="fill: #fff;"></path>
                </svg>
              </div>
            </label>
          `;
        });
      } else {
        productsHtml = `
          <div class="no-products-message" style="text-align: center; padding: 30px 20px; background: #f5f5f5; border-radius: 8px; margin: 10px 0;">
            <p style="margin: 0; color: #666;">No products currently available for this step.</p>
            <p style="margin: 10px 0 0; font-size: 14px; color: #888;">Products will appear once they're configured in your routine.</p>
          </div>
        `;
        debugLog(`No products or fallbacks available for ${fieldName}`);
      }
    }
    
    // Update the container with product HTML
    console.log(`[SKIN-QUIZ-NEW] Setting innerHTML for ${containerClass} with ${products.length} products`);
    container.innerHTML = productsHtml;
    
    // Debug what was actually inserted into the DOM
    console.log(`[SKIN-QUIZ-NEW] After update, container ${containerClass} now contains:`, 
      container.children.length, 'children, first child is:', 
      container.children.length > 0 ? container.children[0].tagName : 'none');
    
    // Initialize event handlers for product cards and quantity buttons
    initProductInteraction(container);
  }
  
  // Function to get fallback products based on the field name
  // NOTE: Removed hardcoded product IDs that could become stale.
  // Products should be configured in Shopify metaobjects.
  // If no products are found, the UI will show "No products available" message.
  function getFallbackProducts(fieldName) {
    debugLog(`No fallback products configured for ${fieldName}`);
    // Return empty array - let the UI handle displaying "No products available"
    return [];
  }
  
  // Function to initialize product interactions
  function initProductInteraction(container) {
    // Add click handlers for quantity buttons - REMOVED, handled by delegated listener
    // container.querySelectorAll('.quantity-btn').forEach(btn => { ... });
    
    // Product cards - REMOVED, handled by delegated listener
    // container.querySelectorAll('.custom-product-card').forEach(card => { ... });
    
    // Checkboxes - REMOVED, handled by delegated listener
    // container.querySelectorAll('.custom-input').forEach(input => { ... });
    
    // Close buttons - REMOVED, handled by delegated listener
    // container.querySelectorAll('.closebtn').forEach(btn => { ... });
    console.log(`[SKIN-QUIZ-NEW] initProductInteraction called for ${container.className}, but direct handlers are removed (using delegation).`);
  }
  
  // Update the item count in the sidebar and calculate total price
  function updateItemCount() {
    let total = 0;
    const selectedProducts = {};
    const stepQuantities = {}; // E.g., { "1-am": 0, "1-pm": 0, "2": 0, ... }
    const countedVariants = new Set(); // Track variant IDs to avoid double-counting AM/PM

    // Initialize all potential step counters to 0 by querying them from the DOM
    // This ensures we only try to update counters that exist.
    document.querySelectorAll('[class*="itemcount"]').forEach(el => {
      const match = el.className.match(/itemcount([\w-]+)/);
      if (match && match[1]) {
        // Ensure we don't overwrite if multiple classes map to same logical key (though unlikely here)
        if (!(match[1] in stepQuantities)) { 
            stepQuantities[match[1]] = 0;
        }
      }
    });
    
    document.querySelectorAll('.custom-input:checked').forEach(checkbox => {
      const accordionCustomItem = checkbox.closest('.accordion-custom-item');
      if (!accordionCustomItem) {
        debugWarn(' Checkbox found without parent .accordion-custom-item:', checkbox);
        return;
      }

      const h2 = accordionCustomItem.querySelector('.accordion h2');
      if (!h2) {
        debugWarn(' .accordion-custom-item found without h2:', accordionCustomItem);
        return;
      }
      
      const stepText = h2.textContent.trim(); // e.g., "1. Cleanser" or "2. Eye Cream"
      const stepNumberMatch = stepText.match(/^(\d+)\./);
      if (!stepNumberMatch) {
        debugWarn(' Step H2 text does not start with number:', stepText);
        return;
      }
      const stepNumber = stepNumberMatch[1];
      const stepName = stepText.substring(stepText.indexOf('.') + 1).trim();

      const price = parseFloat(checkbox.getAttribute('product-price') || 0);
      const quantityInput = checkbox.closest('label')?.querySelector('.quantity-input');
      const quantity = quantityInput ? (parseInt(quantityInput.value, 10) || 1) : 1; // Default to 1 if NaN or 0

      const variantId = checkbox.value;

      // Only add price once per variant (same product in AM and PM shouldn't double-count)
      if (!countedVariants.has(variantId)) {
        total += price * quantity;
        countedVariants.add(variantId);
      }

      let countKeySuffix = "";
      if (stepName.toLowerCase() === 'cleanser') {
        const productSlider = checkbox.closest('.custom-products-slider');
        if (productSlider) {
          if (productSlider.classList.contains('am-products')) {
            countKeySuffix = "-am";
          } else if (productSlider.classList.contains('pm-products')) {
            countKeySuffix = "-pm";
          }
        }
      }

      const fullStepKey = `${stepNumber}${countKeySuffix}`;
      if (fullStepKey in stepQuantities) {
        stepQuantities[fullStepKey] += quantity;
      } else {
        stepQuantities[fullStepKey] = quantity;
        console.warn(`[SKIN-QUIZ-NEW] Encountered new step key during processing: ${fullStepKey}. Initializing.`);
      }

      if (variantId) {
        selectedProducts[variantId] = (selectedProducts[variantId] || 0) + quantity;
      }
    });
    
    // Update step count displays in the sidebar
    for (const key in stepQuantities) {
        const itemCountElement = document.querySelector(`.itemcount${key}`);
        if (itemCountElement) {
            const currentQuantity = stepQuantities[key];
            itemCountElement.textContent = currentQuantity;
            itemCountElement.style.backgroundColor = currentQuantity > 0 ? '#007d1e' : '#efefef';
            itemCountElement.style.color = currentQuantity > 0 ? '#fff' : '#000';
        } else {
            console.warn(`[SKIN-QUIZ-NEW] Sidebar item count element .itemcount${key} not found.`);
        }
    }
    
    // Update total price display
    const totalElement = document.querySelector('.custom-total');
    if (totalElement) {
      totalElement.textContent = formatMoney(total.toString());
    }

    // Sync bottom bar total price
    var bottomBarTotalPrice = document.getElementById('bottomBarTotalPrice');
    if (bottomBarTotalPrice) {
      bottomBarTotalPrice.textContent = formatMoney(total.toString());
    }

    // Update "Add to Cart" button style
    const buttonCustom = document.querySelector('.button-custom');
    if (buttonCustom) {
        if (document.querySelectorAll('.custom-input:checked').length > 0) {
            buttonCustom.style.backgroundColor = '#000';
            buttonCustom.style.color = '#fff';
        } else {
            buttonCustom.style.backgroundColor = '#ccc';
            buttonCustom.style.color = '#000';
        }
    }

    // Store selected products in localStorage
    localStorage.setItem(STORAGE_KEYS.SELECTED_PRODUCTS, JSON.stringify(selectedProducts));

    debugLog(' Updated item counts:', stepQuantities);
    debugLog(' Updated total price:', formatMoney(total.toString()));
    debugLog(' Selected products for cart:', selectedProducts);

    return total;
  }
  
  // Function to toggle between day and night products
  function toggleDayNight(button, time, stepName) {
    // Remove active class from all buttons in this group
    const buttonGroup = button.parentElement;
    buttonGroup.querySelectorAll('.toggle-btn').forEach(btn => btn.classList.remove('active'));

    // Add active class to clicked button
    button.classList.add('active');

    // Apply enhanced icon/button styling
    if (typeof updateToggleStyles === 'function') {
      updateToggleStyles(buttonGroup, time);
    }
    
    // Toggle product visibility
    const amProducts = document.querySelector(`.${stepName}-am-products`);
    const pmProducts = document.querySelector(`.${stepName}-pm-products`);
    
    if (amProducts && pmProducts) {
      // Unslick both sliders first if they are initialized
      if ($(amProducts).hasClass('slick-initialized')) {
        $(amProducts).slick('unslick');
      }
      if ($(pmProducts).hasClass('slick-initialized')) {
        $(pmProducts).slick('unslick');
      }
      
      // Toggle display
      amProducts.style.display = time === 'am' ? 'block' : 'none';
      pmProducts.style.display = time === 'pm' ? 'block' : 'none';
      
      // Reinitialize the visible slider using shared config
      const activeSlider = time === 'am' ? amProducts : pmProducts;
      if (activeSlider.children.length > 0) {
        $(activeSlider).slick(SLICK_CONFIG);
      } else {
        debugLog(`No products in ${time} slider for ${stepName}, skipping Slick init.`);
      }

      // Update UI after toggling and re-initializing slider
      const accordionItem = button.closest('.accordion-custom-item');
      const contentPanel = accordionItem?.querySelector('.accordion-custom-content');
      if (contentPanel) {
          // safeUpdateCartTotal(); // OLD CALL
          // safeUpdateItemCount(contentPanel); // OLD CALL
          refreshAllSkincareStepUI(); // NEW CALL
      } else {
          debugWarn(' Could not find content panel after day/night toggle.');
          refreshAllSkincareStepUI(); // Still try to refresh global state
      }
    }
  }
  
  // Valid values for skin quiz profile fields
  const VALID_SKIN_TYPES = ['Dry', 'Oily', 'Combination', 'Normal'];
  const VALID_SENSITIVITY = ['Sensitive', 'Not Sensitive'];
  const VALID_CONCERNS = [
    'Acne-Prone', 'Hyperpigmentation', 'Redness/Rosacea',
    'Fine Lines/Wrinkles', 'Dark Circles', 'Dehydration',
    'Uneven Texture', 'Dullness'
  ];

  // Validate and sanitize the quiz profile data
  function validateQuizProfile(data) {
    if (!data || typeof data !== 'object') {
      debugWarn('Quiz profile data is not a valid object');
      return null;
    }

    // Create a sanitized copy
    const sanitized = {};

    // Validate skin type (required)
    if (data.skinType && VALID_SKIN_TYPES.includes(data.skinType)) {
      sanitized.skinType = data.skinType;
    } else {
      debugWarn('Invalid or missing skinType in quiz profile:', data.skinType);
      return null; // Skin type is required
    }

    // Validate sensitivity (required)
    if (data.sensitivity && VALID_SENSITIVITY.includes(data.sensitivity)) {
      sanitized.sensitivity = data.sensitivity;
    } else {
      // Default to 'Not Sensitive' if invalid
      sanitized.sensitivity = 'Not Sensitive';
    }

    // Validate primary concern (optional)
    if (data.primaryConcern && VALID_CONCERNS.includes(data.primaryConcern)) {
      sanitized.primaryConcern = data.primaryConcern;
    }

    // Validate concerns array (optional)
    if (Array.isArray(data.concerns)) {
      sanitized.concerns = data.concerns.filter(c => VALID_CONCERNS.includes(c));
    }

    // Validate name (optional, sanitize string)
    if (data.name && typeof data.name === 'string') {
      // Limit name length and remove potentially harmful characters
      sanitized.name = data.name.substring(0, 100).replace(/[<>'"&]/g, '');
    }

    // Validate isPregnant (optional, boolean)
    if (typeof data.isPregnant === 'boolean') {
      sanitized.isPregnant = data.isPregnant;
    }

    // Validate sunscreen preferences (optional)
    if (data.sunscreenPrefs && typeof data.sunscreenPrefs === 'object') {
      const validTypes = ['Physical', 'Chemical', 'NoPreference'];
      const validColors = ['Tinted', 'Untinted'];

      sanitized.sunscreenPrefs = {};
      if (validTypes.includes(data.sunscreenPrefs.type)) {
        sanitized.sunscreenPrefs.type = data.sunscreenPrefs.type;
      }
      if (validColors.includes(data.sunscreenPrefs.color)) {
        sanitized.sunscreenPrefs.color = data.sunscreenPrefs.color;
      }
    }

    return sanitized;
  }

  // Function to load skin quiz data if available
  function loadSkinQuizData() {
    let savedProfile;

    try {
      savedProfile = localStorage.getItem(STORAGE_KEYS.QUIZ_PROFILE);
    } catch (storageError) {
      debugError('Error accessing localStorage:', storageError);
      return null;
    }

    if (savedProfile) {
      try {
        const profileData = JSON.parse(savedProfile);

        // Validate the data structure and values
        const validatedData = validateQuizProfile(profileData);

        if (validatedData) {
          debugLog('Skin profile data loaded and validated:', validatedData);
          updatePageHeader(validatedData);
          return validatedData;
        } else {
          debugWarn('Quiz profile failed validation, clearing invalid data');
          // Optionally clear invalid data
          try {
            localStorage.removeItem(STORAGE_KEYS.QUIZ_PROFILE);
          } catch (e) {
            debugError('Could not clear invalid profile data:', e);
          }
          return null;
        }
      } catch (parseError) {
        debugError('Error parsing skin quiz profile JSON:', parseError);
        // Clear corrupted data
        try {
          localStorage.removeItem(STORAGE_KEYS.QUIZ_PROFILE);
        } catch (e) {
          debugError('Could not clear corrupted profile data:', e);
        }
        return null;
      }
    }
    return null;
  }
  
  // Update the page header with skin profile info
  function updatePageHeader(profileData) {
    if (!profileData) return;

    // Update the new results header title with user's name
    const resultsTitle = document.getElementById('resultsUserName');
    if (resultsTitle) {
      const userName = profileData.name || 'Your';
      resultsTitle.textContent = `${userName}'s Ritual`;
    }

    // Update the title to be more personalized (legacy support)
    const descriptionElement = document.querySelector('.custom-description');
    if (descriptionElement) {
      const titleElement = descriptionElement.querySelector('h1');
      const descElement = descriptionElement.querySelector('p');

      if (titleElement) {
        titleElement.textContent = `${profileData.name || 'Your'} Personalized Skincare Routine`;
      }

      if (descElement) {
        const skinType = profileData.skinType || '';
        // Correctly access concerns which might be an array or string
        let concernsText = '';
        if (profileData.concerns) {
            if (Array.isArray(profileData.concerns)) {
                concernsText = profileData.concerns.join(', ');
            } else if (typeof profileData.concerns === 'string') {
                concernsText = profileData.concerns;
            }
        }

        descElement.innerHTML = `Based on your <strong>${skinType}</strong> skin type${concernsText ? ` and ${concernsText} concerns` : ''}, we've created the perfect routine. Toggle between day and night to see recommendations for each time of day.`;
      }
    }
  }
  
  // Escape HTML to prevent XSS attacks
  function escapeHtml(text) {
    if (text == null) return '';
    const div = document.createElement('div');
    div.textContent = String(text);
    return div.innerHTML;
  }

  // Format money - handles both cents (integer) and formatted strings
  function formatMoney(amount) {
    // Handle null/undefined
    if (amount == null) return '$0.00';

    let cents;

    if (typeof amount === 'string') {
      // Remove currency symbols and whitespace
      const cleaned = amount.replace(/[$,\s]/g, '');

      // Check if it's a decimal string like "21.00" or integer string like "2100"
      if (cleaned.includes('.')) {
        // It's a formatted price like "21.00" - convert to cents
        cents = Math.round(parseFloat(cleaned) * 100);
      } else {
        // It's already in cents like "2100"
        cents = parseInt(cleaned, 10);
      }
    } else if (typeof amount === 'number') {
      // If it's a small number (< 1000), assume it's dollars, else cents
      // Most products are > $10 so this heuristic works
      cents = amount < 1000 ? Math.round(amount * 100) : Math.round(amount);
    } else {
      cents = 0;
    }

    // Ensure it's a valid number
    if (isNaN(cents)) cents = 0;

    const dollars = Math.floor(Math.abs(cents) / 100);
    const centsPart = (Math.abs(cents) % 100).toString().padStart(2, '0');
    const sign = cents < 0 ? '-' : '';

    return `${sign}$${dollars}.${centsPart}`;
  }

  // Update the item count in the sidebar and calculate total price 
  // RENAMED and REPURPOSED as the main UI refresh function
  function refreshAllSkincareStepUI() {
    debugLog(' Executing refreshAllSkincareStepUI');
    let total = 0;
    const selectedProductsForCart = {}; // For potential cart submission
    const stepQuantities = {}; // E.g., { "1-am": 0, "1-pm": 0, "2": 0, ... }
    const countedVariantsRefresh = new Set(); // Track variant IDs to avoid double-counting AM/PM

    // Initialize all potential step counters to 0 by querying them from the DOM
    document.querySelectorAll('[class*="itemcount"]').forEach(el => {
      const match = el.className.match(/itemcount([\w-]+)/);
      if (match && match[1]) {
        if (!(match[1] in stepQuantities)) {
            stepQuantities[match[1]] = 0;
        }
      }
    });

    document.querySelectorAll('.custom-input:checked').forEach(checkbox => {
      const accordionCustomItem = checkbox.closest('.accordion-custom-item');
      if (!accordionCustomItem) {
        debugWarn(' Checkbox found without parent .accordion-custom-item:', checkbox);
        return;
      }

      const h2 = accordionCustomItem.querySelector('.accordion h2');
      if (!h2) {
        debugWarn(' .accordion-custom-item found without h2:', accordionCustomItem);
        return;
      }

      const stepText = h2.textContent.trim();
      const stepNumberMatch = stepText.match(/^(\d+)\./);
      if (!stepNumberMatch) {
        debugWarn(' Step H2 text does not start with number:', stepText);
        return;
      }
      const stepNumber = stepNumberMatch[1];
      const stepName = stepText.substring(stepText.indexOf('.') + 1).trim();

      const price = parseFloat(checkbox.getAttribute('product-price') || 0);
      const quantityInput = checkbox.closest('label')?.querySelector('.quantity-input');
      const quantity = quantityInput ? (parseInt(quantityInput.value, 10) || 1) : 1;

      const variantId = checkbox.value;

      // Only add price once per variant (same product in AM and PM shouldn't double-count)
      if (!countedVariantsRefresh.has(variantId)) {
        total += price * quantity;
        countedVariantsRefresh.add(variantId);
      }

      let countKeySuffix = "";
      if (stepName.toLowerCase() === 'cleanser') {
        const productSlider = checkbox.closest('.custom-products-slider');
        if (productSlider) {
          if (productSlider.classList.contains('am-products')) {
            countKeySuffix = "-am";
          } else if (productSlider.classList.contains('pm-products')) {
            countKeySuffix = "-pm";
          }
        }
      }

      const fullStepKey = `${stepNumber}${countKeySuffix}`;
      if (fullStepKey in stepQuantities) {
        stepQuantities[fullStepKey] += quantity;
      } else {
        stepQuantities[fullStepKey] = quantity;
        console.warn(`[SKIN-QUIZ-NEW] Encountered new step key during processing: ${fullStepKey}. Initializing.`);
      }

      if (variantId) {
        selectedProductsForCart[variantId] = (selectedProductsForCart[variantId] || 0) + quantity;
      }
    });
    
    // Update step count displays in the sidebar
    for (const key in stepQuantities) {
        const itemCountElement = document.querySelector(`.itemcount${key}`);
        if (itemCountElement) {
            const currentQuantity = stepQuantities[key];
            itemCountElement.textContent = currentQuantity;
            itemCountElement.style.backgroundColor = currentQuantity > 0 ? '#007d1e' : '#efefef';
            itemCountElement.style.color = currentQuantity > 0 ? '#fff' : '#000';
        } else {
            console.warn(`[SKIN-QUIZ-NEW] Sidebar item count element .itemcount${key} not found.`);
        }
    }
    
    // Update total price display
    const totalElement = document.querySelector('.custom-total');
    if (totalElement) {
      totalElement.textContent = formatMoney(total.toString());
    }

    // Sync bottom bar total price
    var bottomBarTotalPrice = document.getElementById('bottomBarTotalPrice');
    if (bottomBarTotalPrice) {
      bottomBarTotalPrice.textContent = formatMoney(total.toString());
    }

    // Update "Add to Cart" button style
    const buttonCustom = document.querySelector('.button-custom');
    if (buttonCustom) {
        if (document.querySelectorAll('.custom-input:checked').length > 0) {
            buttonCustom.style.backgroundColor = '#000';
            buttonCustom.style.color = '#fff';
        } else {
            buttonCustom.style.backgroundColor = '#ccc';
            buttonCustom.style.color = '#000';
        }
    }

    // Store selected products in localStorage
    localStorage.setItem(STORAGE_KEYS.SELECTED_PRODUCTS, JSON.stringify(selectedProductsForCart));

    // Update sticky cart bar visibility and count
    if (typeof updateStickyCartBar === 'function') {
      updateStickyCartBar();
    }

    debugLog(' Refreshed item counts:', stepQuantities);
    debugLog(' Refreshed total price:', formatMoney(total.toString()));
    debugLog(' Refreshed products for cart (localStorage):', selectedProductsForCart);

    return total;
  }

  // Debounced version of refreshAllSkincareStepUI for better performance
  // Waits 150ms after last call before executing
  const debouncedRefreshUI = debounce(refreshAllSkincareStepUI, 150);

  // Initialize: load product data when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadProductData);
  } else {
    loadProductData();
  }

  // Mobile sticky bar: track which step is currently in view
  function initMobileBarStepTracker() {
    var mobileBarStep = document.getElementById('mobileBarStep');
    if (!mobileBarStep) return;

    var steps = document.querySelectorAll('.accordion-custom');
    if (!steps.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var heading = entry.target.querySelector('.accordion h2');
          if (heading) {
            mobileBarStep.textContent = heading.textContent.trim();
          }
        }
      });
    }, {
      rootMargin: '-20% 0px -60% 0px',
      threshold: 0
    });

    steps.forEach(function(step) {
      observer.observe(step);
    });
  }

  // Init the step tracker after products load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initMobileBarStepTracker, 1000);
    });
  } else {
    setTimeout(initMobileBarStepTracker, 1000);
  }

// ============================================
// FEATURE: Close Routine Builder (X button)
// ============================================
function closeRoutineBuilder() {
  // Try to go back in history, otherwise navigate to homepage
  if (window.history.length > 1) {
    window.history.back();
  } else {
    window.location.href = '/';
  }
}

// Initialize close button handler
function initCloseButton() {
  var closeBtn = document.querySelector('.ebc-close-btn');
  if (closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      closeRoutineBuilder();
    });
    debugLog('Close button handler attached');
  }
}

// ============================================
// FEATURE: Enhanced AM/PM Toggle with Icons
// ============================================
function updateToggleStyles(buttonGroup, activeTime) {
  var amBtn = buttonGroup.querySelector('.am-btn');
  var pmBtn = buttonGroup.querySelector('.pm-btn');

  if (amBtn) {
    if (activeTime === 'am') {
      // AM active: white bg, gold text/icon
      amBtn.style.backgroundColor = '#fff';
      amBtn.style.color = '#b8860b';
      amBtn.style.transition = 'all 0.3s ease';
      var sunIcon = amBtn.querySelector('.sun-icon');
      if (sunIcon) {
        sunIcon.style.stroke = '#b8860b';
        sunIcon.style.transition = 'stroke 0.3s ease';
      }
    } else {
      // AM inactive
      amBtn.style.backgroundColor = '';
      amBtn.style.color = '';
      var sunIcon = amBtn.querySelector('.sun-icon');
      if (sunIcon) {
        sunIcon.style.stroke = '';
      }
    }
  }

  if (pmBtn) {
    if (activeTime === 'pm') {
      // PM active: black bg, white text/icon
      pmBtn.style.backgroundColor = '#000';
      pmBtn.style.color = '#fff';
      pmBtn.style.transition = 'all 0.3s ease';
      var moonIcon = pmBtn.querySelector('.moon-icon');
      if (moonIcon) {
        moonIcon.style.stroke = '#fff';
        moonIcon.style.transition = 'stroke 0.3s ease';
      }
    } else {
      // PM inactive
      pmBtn.style.backgroundColor = '';
      pmBtn.style.color = '';
      var moonIcon = pmBtn.querySelector('.moon-icon');
      if (moonIcon) {
        moonIcon.style.stroke = '';
      }
    }
  }
}

// ============================================
// FEATURE: Desktop Sidebar Step Navigation
// ============================================
var currentActiveStep = 0;

function setActiveStep(stepIndex) {
  currentActiveStep = stepIndex;

  // Update sidebar step styling
  var sidebarSteps = document.querySelectorAll('#routine-categories > div');
  sidebarSteps.forEach(function(step, idx) {
    if (idx === stepIndex) {
      step.classList.add('active-step');
      step.style.transform = 'scale(1.02)';
      step.style.borderLeft = '3px solid #b8860b';
      step.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
      step.style.transition = 'all 0.3s ease';
    } else {
      step.classList.remove('active-step');
      step.style.transform = '';
      step.style.borderLeft = '';
      step.style.boxShadow = '';
    }
  });

  // Scroll to corresponding product section
  var accordionItems = document.querySelectorAll('.accordion-custom');
  if (accordionItems[stepIndex]) {
    accordionItems[stepIndex].scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  // Update mobile step indicator
  updateMobileStepIndicator(stepIndex);

  debugLog('Active step set to:', stepIndex);
}

function initSidebarStepNavigation() {
  var sidebarSteps = document.querySelectorAll('#routine-categories > div');
  sidebarSteps.forEach(function(step, idx) {
    step.style.cursor = 'pointer';
    step.addEventListener('click', function() {
      setActiveStep(idx);
    });
  });
  debugLog('Sidebar step navigation initialized');
}

// ============================================
// FEATURE: Mobile Horizontal Step Scroll
// ============================================
function updateMobileStepIndicator(stepIndex) {
  var mobileStepTabs = document.querySelectorAll('.mobile-step-tab');
  mobileStepTabs.forEach(function(tab, idx) {
    if (idx === stepIndex) {
      tab.classList.add('active');
      tab.style.backgroundColor = '#b8860b';
      tab.style.color = '#fff';
      // Scroll tab into view if needed
      tab.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    } else {
      tab.classList.remove('active');
      tab.style.backgroundColor = '';
      tab.style.color = '';
    }
  });

  // Also update the mobile bar step text
  var mobileBarStep = document.getElementById('mobileBarStep');
  var accordionItems = document.querySelectorAll('.accordion-custom');
  if (mobileBarStep && accordionItems[stepIndex]) {
    var heading = accordionItems[stepIndex].querySelector('.accordion h2');
    if (heading) {
      mobileBarStep.textContent = heading.textContent.trim();
    }
  }
}

function initMobileStepScroll() {
  var mobileStepContainer = document.querySelector('.mobile-step-tabs');
  if (mobileStepContainer) {
    // Add scroll snap behavior via JS (CSS should also have it)
    mobileStepContainer.style.scrollSnapType = 'x mandatory';
    mobileStepContainer.style.overflowX = 'auto';
    mobileStepContainer.style.webkitOverflowScrolling = 'touch';

    var tabs = mobileStepContainer.querySelectorAll('.mobile-step-tab');
    tabs.forEach(function(tab, idx) {
      tab.style.scrollSnapAlign = 'center';
      tab.style.cursor = 'pointer';
      // Add click handler to navigate to step
      tab.addEventListener('click', function() {
        setActiveStep(idx);
      });
    });
  }

  // Use IntersectionObserver to detect which step is in view
  var accordionItems = document.querySelectorAll('.accordion-custom');
  if (accordionItems.length === 0) return;

  var stepObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
        var stepIndex = Array.from(accordionItems).indexOf(entry.target);
        if (stepIndex !== -1 && stepIndex !== currentActiveStep) {
          currentActiveStep = stepIndex;
          updateMobileStepIndicator(stepIndex);

          // Update sidebar highlighting too
          var sidebarSteps = document.querySelectorAll('#routine-categories > div');
          sidebarSteps.forEach(function(step, idx) {
            if (idx === stepIndex) {
              step.classList.add('active-step');
              step.style.transform = 'scale(1.02)';
              step.style.borderLeft = '3px solid #b8860b';
              step.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
            } else {
              step.classList.remove('active-step');
              step.style.transform = '';
              step.style.borderLeft = '';
              step.style.boxShadow = '';
            }
          });
        }
      }
    });
  }, {
    rootMargin: '-20% 0px -50% 0px',
    threshold: [0.1, 0.3, 0.5]
  });

  accordionItems.forEach(function(item) {
    stepObserver.observe(item);
  });

  debugLog('Mobile step scroll initialized with IntersectionObserver');
}

// ============================================
// FEATURE: Sticky Cart Bar Logic
// ============================================
var stickyCartBarVisible = false;

function showStickyCartBar() {
  var stickyBar = document.querySelector('.sticky-cart-bar, .mobile-sticky-bar');
  if (stickyBar && !stickyCartBarVisible) {
    stickyBar.style.transform = 'translateY(0)';
    stickyBar.style.opacity = '1';
    stickyBar.style.visibility = 'visible';
    stickyBar.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
    stickyCartBarVisible = true;
    debugLog('Sticky cart bar shown');
  }
}

function hideStickyCartBar() {
  var stickyBar = document.querySelector('.sticky-cart-bar, .mobile-sticky-bar');
  if (stickyBar && stickyCartBarVisible) {
    stickyBar.style.transform = 'translateY(100%)';
    stickyBar.style.opacity = '0';
    // Use transitionend to set visibility after animation
    stickyBar.addEventListener('transitionend', function handler() {
      if (!stickyCartBarVisible) {
        stickyBar.style.visibility = 'hidden';
      }
      stickyBar.removeEventListener('transitionend', handler);
    });
    stickyCartBarVisible = false;
    debugLog('Sticky cart bar hidden');
  }
}

function updateStickyCartBar() {
  var checkedItems = document.querySelectorAll('.custom-input:checked');
  var itemCount = checkedItems.length;

  // Update item count badge
  var countBadge = document.querySelector('.cart-item-count, .sticky-cart-count');
  if (countBadge) {
    countBadge.textContent = itemCount;
  }

  // Show/hide based on selection
  if (itemCount > 0) {
    showStickyCartBar();
  } else {
    hideStickyCartBar();
  }
}

function initStickyCartBar() {
  var stickyBar = document.querySelector('.sticky-cart-bar, .mobile-sticky-bar');
  if (stickyBar) {
    // Set initial state (hidden)
    stickyBar.style.transform = 'translateY(100%)';
    stickyBar.style.opacity = '0';
    stickyBar.style.visibility = 'hidden';
    stickyBar.style.position = 'fixed';
    stickyBar.style.bottom = '0';
    stickyBar.style.left = '0';
    stickyBar.style.right = '0';
    stickyBar.style.zIndex = '1000';
  }
  debugLog('Sticky cart bar initialized');
}

// ============================================
// FEATURE: Product Card Hover Effects
// ============================================
function initProductCardHoverEffects() {
  // Add overflow:hidden to product card containers for image zoom effect
  var productCards = document.querySelectorAll('.custom-product-card');
  productCards.forEach(function(card) {
    card.style.overflow = 'hidden';

    var img = card.querySelector('img');
    if (img) {
      img.style.transition = 'transform 0.3s ease';

      card.addEventListener('mouseenter', function() {
        img.style.transform = 'scale(1.05)';
      });

      card.addEventListener('mouseleave', function() {
        img.style.transform = 'scale(1)';
      });
    }
  });
  debugLog('Product card hover effects initialized');
}

// Re-initialize hover effects when new products are loaded
function reinitProductCardHoverEffects() {
  // Use MutationObserver to watch for new product cards
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            var cards = node.querySelectorAll ? node.querySelectorAll('.custom-product-card') : [];
            cards.forEach(function(card) {
              card.style.overflow = 'hidden';
              var img = card.querySelector('img');
              if (img) {
                img.style.transition = 'transform 0.3s ease';
                card.addEventListener('mouseenter', function() {
                  img.style.transform = 'scale(1.05)';
                });
                card.addEventListener('mouseleave', function() {
                  img.style.transform = 'scale(1)';
                });
              }
            });
          }
        });
      }
    });
  });

  var container = document.getElementById('routine-steps-container');
  if (container) {
    observer.observe(container, { childList: true, subtree: true });
  }
}

// ============================================
// ENHANCED: Update toggleDayNight with icon styles
// ============================================
// Wrap original toggleDayNight to add icon styling
var originalToggleDayNight = typeof toggleDayNight !== 'undefined' ? toggleDayNight : null;

// ============================================
// Initialize all new features
// ============================================
function initAllNewFeatures() {
  initCloseButton();
  initSidebarStepNavigation();
  initMobileStepScroll();
  initStickyCartBar();
  initProductCardHoverEffects();
  reinitProductCardHoverEffects();
  initToggleButtonStyles();

  // Initial sticky cart bar state check
  updateStickyCartBar();

  debugLog('All new features initialized');
}

// Initialize toggle button styles on page load
function initToggleButtonStyles() {
  var toggleGroups = document.querySelectorAll('.day-night-toggle');
  toggleGroups.forEach(function(group) {
    var activeBtn = group.querySelector('.toggle-btn.active');
    if (activeBtn) {
      var isAM = activeBtn.classList.contains('am-btn');
      updateToggleStyles(group, isAM ? 'am' : 'pm');
    }
  });
  debugLog('Toggle button styles initialized');
}

// Run initialization after DOM is ready and products are loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(initAllNewFeatures, 1500); // Wait for products to load
  });
} else {
  setTimeout(initAllNewFeatures, 1500);
}

// ============================================
// PUBLIC API - Expose necessary functions
// ============================================
// These functions need to be globally accessible for onclick handlers in HTML
window.SkinQuizResults = {
  toggleDayNight: toggleDayNight,
  refreshUI: refreshAllSkincareStepUI,
  formatMoney: formatMoney,
  // New feature functions
  closeRoutineBuilder: closeRoutineBuilder,
  setActiveStep: setActiveStep,
  updateStickyCartBar: updateStickyCartBar,
  showStickyCartBar: showStickyCartBar,
  hideStickyCartBar: hideStickyCartBar,
  // Debug utilities (only work when SKIN_QUIZ_DEBUG is true)
  debug: {
    log: debugLog,
    warn: debugWarn,
    error: debugError,
    enableDebug: function() {
      // Note: This won't actually enable debug since SKIN_QUIZ_DEBUG is const
      // To enable debugging, set SKIN_QUIZ_DEBUG = true at the top of the file
      console.log('[SKIN-QUIZ-NEW] To enable debug mode, set SKIN_QUIZ_DEBUG = true at the top of section-skin-quiz-new.js');
    }
  }
};
